const s = {
  name: "CalendarContacts",
  dimensions: { width: 38, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 38 40" style="enable-background:new 0 0 38 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M19,15c-2.2,0-4,1.8-4,4c0,2.2,1.8,4,4,4s4-1.8,4-4C23,16.8,21.2,15,19,15z M17,19c0-1.1,0.9-2,2-2s2,0.9,2,2
			c0,1.1-0.9,2-2,2S17,20.1,17,19z"/>
		<path class="st0" d="M14,30c0-1.7,1.3-3,3-3h4c1.7,0,3,1.3,3,3v3h2v-3c0-2.8-2.2-5-5-5h-4c-2.8,0-5,2.2-5,5v3h2V30z"/>
		<path class="st0" d="M10,2h18V0h2v2h3c2.8,0,5,2.2,5,5v28c0,2.8-2.2,5-5,5H5c-2.8,0-5-2.2-5-5V7c0-2.8,2.2-5,5-5h3V0h2V2z M8,4H5
			C3.3,4,2,5.3,2,7v1h34V7c0-1.7-1.3-3-3-3h-3v2h-2V4H10v2H8V4z M2,35c0,1.7,1.3,3,3,3h28c1.7,0,3-1.3,3-3V10H2V35z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as CalendarContacts
};
